import {YAxisConfig} from '../../../types/GraphTypes';

export function getGraphRendererYDomain(config: YAxisConfig): [number | 'dataMin', number | 'dataMax'] {
  if (config.min !== undefined || config.max !== undefined) {
    // Use 'auto' for dataMin/dataMax to ensure all data is visible
    const min = config.min !== undefined ? config.min : 'dataMin';
    const max = config.max !== undefined ? config.max : 'dataMax';
    return [min, max];
  }
  // Always return domain, defaulting to dataMin/dataMax for auto-calculation
  return ['dataMin', 'dataMax'];
}
